/** @jsx h */
import { h } from 'preact'

const AnimalWelfare = () => (
  <svg width={28} height={32}>
    <g fill='none' fillRule='evenodd' stroke='#2F3A4A'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14 3c1 0 2.5.5 4 1s3 3 4 2.5S23 5 24 5s3.048 2.365 4 3c-5 6.5-4.5 3-6.5 2.5.667.667.667 1.667 0 3-2.333 4.333-3 6.833-2 7.5 1.5 1 1 4 0 4.5s-2 1-2.5 2-1.5 1-3 1-2.5 0-3-1-1.5-1.5-2.5-2S7 22 8.5 21c1-.667.333-3.167-2-7.5-.667-1.333-.667-2.333 0-3C4.5 11 5 14.5 0 8c.952-.635 3-3 4-3s1 1 2 1.5 2.5-2 4-2.5 3-1 4-1z'
      />
      <path d='M12 22l-.5-1.5M16 22l.5-1.5M11 25h6M9 10c-.333 1.333-.167 2.333.5 3M18.667 10c.333 1.333.167 2.333-.5 3' />
    </g>
  </svg>
)

export default AnimalWelfare
